import React, {useState, useEffect} from 'react';
import moment from 'moment';

export const fixedLength = (val, prefix = '0', len = 2)=>{
  val = val + '';
  while(val && val.length < len) {
    val = prefix + val;
  }
  return val;
};

export default (props)=>{
  let {title, value, endTime, isStatic} = props;

  const [showTime, setShowTime] = useState('00:00:00');

  const getShowTime = ()=>{
    let endValue = (Date.now() > moment(endTime).valueOf()) ? moment(endTime).valueOf() : Date.now();
    let between = endValue - value;
    let duration = moment.duration(between);
    setShowTime(`${fixedLength(duration.hours())}:${fixedLength(duration.minutes())}:${fixedLength(duration.seconds())}`);
  };

  useEffect(()=>{
    getShowTime();
    if(!isStatic) {
      const timer = setInterval(getShowTime, 1000);
      return ()=>{
        clearInterval(timer);
      }
    }
  }, [value, isStatic]);

  return <div className="ant-statistic">
    <div className="ant-statistic-title">{title}</div>
    <div className="ant-statistic-content">
      <span className="ant-statistic-content-value">{showTime}</span>
    </div>
  </div>;
};



// WEBPACK FOOTER //
// ./src/components/Video/Countup.js